

// src/redux/cardsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../utils/Constants';

// Async thunk for fetching data
export const fetchEarnAsync = createAsyncThunk('Earn/fetchEarn', async () => {
  const token = localStorage.getItem("Token")
  const headers = {
    "Authorization": token, "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  }
  try {
    const response = await axios.get(`${BASE_URL}/v1/nanny/getEarnings`, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
});

const EarnSlice = createSlice({
  name: 'Earning',
  initialState: {
    data: null,
    loading: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEarnAsync.pending, (state) => {
        state.loading = 'pending';
      })
      .addCase(fetchEarnAsync.fulfilled, (state, action) => {
        state.loading = 'idle';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchEarnAsync.rejected, (state, action) => {
        state.loading = 'idle';
        state.error = action.error.message;
      });
  },
});

export default EarnSlice.reducer;
